/* eslint no-unused-vars: "off" */
import React from 'react';
import {
  Grid,
  Col,
  Row,
  InputGroup,
  Button,
} from 'react-bootstrap';
import {
  calculateUnlinkedObject,
  calculateUnlinked,
  formatNumber,
} from './BaseElement.jsx';
import Label from '@/component/form/Label.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import {
  setLinkSavingAllowed, setQuantity, setLinkFirst, setBlQuantity,
  setLinkLast, setBLDate, setNoTransportBl,
} from '@/store/links.store.js';
import { connect } from 'react-redux';
import { List, fromJS } from 'immutable';
import RequiredFormControl from '../../../form/RequiredFormControl.jsx';
import Select from 'react-select';
import _ from 'lodash';
import { handleFormChanged } from '@/store/allaround.store.js';
import AlertPopover from '@/util/AlertPopover.jsx';
import {
  DateTimePicker2 as DateTimePicker, Radio,
  Checkbox,
} from '../../../form/FormControls';
import { dateTimePickerFormat } from '../../../../util/util';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import longshort from '../../../../../style/longshort.png';

moment.locale('en');
momentLocalizer();

class Quantity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      init: false,
      showAlert: false,
      validationMessage: '',
      validateAgainstUnlinked: undefined,
      contractOption: 'MUTUAL_OPTION',
    };
    this.setAbsoluteBased = this.setAbsoluteBased.bind(this);
    this.setPercentBased = this.setPercentBased.bind(this);
    this.onContractOptionChange = this.onContractOptionChange.bind(this);
    this.formatQuantityP = this.formatQuantityP.bind(this);
    if (props.isLinking) {
      this.onChangeQuantity = this.onChangeQuantity.bind(this);
      this.onChangeQuantityMin = this.onChangeQuantityMin.bind(this);
      this.onChangeQuantityMax = this.onChangeQuantityMax.bind(this);
      this.onChangeQuantityMinP = this.onChangeQuantityMinP.bind(this);
      this.onChangeQuantityMaxP = this.onChangeQuantityMaxP.bind(this);
    } else {
      this.onChangeQuantity = _.debounce(this.onChangeQuantity.bind(this), 150);
      this.onChangeQuantityMin = _.debounce(this.onChangeQuantityMin.bind(this), 150);
      this.onChangeQuantityMax = _.debounce(this.onChangeQuantityMax.bind(this), 150);
      this.onChangeQuantityMinP = _.debounce(this.onChangeQuantityMinP.bind(this), 150);
      this.onChangeQuantityMaxP = _.debounce(this.onChangeQuantityMaxP.bind(this), 150);
    }
    this.failed = false;
  }

  componentWillMount() {
    this.setNewState(this.props);
  }

  componentWillReceiveProps(props) {
    this.setNewState(props);
    if (this.props.shrinked !== props.shrinked && !props.shrinked) {
      this.setNewState(props, true);
    } else {
      this.setNewState(props);
    }
    if (!props.data.get('billLandingQuantity') && !props.showBLQuantity) {
      if (!this.props.thisElemInState || props.thisElemInState && this.props.thisElemInState &&
        props.thisElemInState.get('failed') !== this.props.thisElemInState.get('failed')) {
        return;
      }
    }
    if (props.unlinkedObject != this.props.unlinkedObject || this.state.quantityMax == '') {
      this.validate(this.state, props, true);
    }
  }

  shouldComponentUpdate(props, state) {
    const newPropsClone = JSON.stringify(props);
    const oldPropsClone = JSON.stringify(this.props);
    const newStateClone = JSON.stringify(state);
    const oldStateClone = JSON.stringify(this.state);
    if (JSON.stringify(newPropsClone) == JSON.stringify(oldPropsClone) &&
      JSON.stringify(newStateClone) == JSON.stringify(oldStateClone)) {
      return false;
    }
    return true;
  }

  onChangeQuantity(ev, modelValue) {
    this.setState({ quantity: modelValue });
    this.quantityChanged(modelValue);
  }

  onChangeQuantityMin(ev, modelValue, viewValue) {
    this.setState({
      quantityMin: modelValue,
      showAlert: modelValue >= this.props.alertOnQuantityGtThan,
    });
    this.props.setQuantity({ min: modelValue, failed: false });
    this.validate({ ...this.state, quantityMin: modelValue });
    if (this.props.onChangeFunc) {
      this.props.onChangeFunc({ ...this.state, quantityMin: modelValue });
    }
    this.props.setLinkFirst();
  }

  onChangeQuantityMax(ev, modelValue, viewValue) {
    this.setState({ quantityMax: modelValue });
    this.props.setQuantity({ max: modelValue, failed: false });
    this.validate({ ...this.state, quantityMax: modelValue });
    if (this.props.onChangeFunc) {
      this.props.onChangeFunc({ ...this.state, quantityMax: modelValue });
    }
    this.props.setLinkFirst();
  }

  onChangeQuantityMinP(ev, val) {
    this.setState({ quantityMinP: val });
    this.quantityMinPChanged(val);
  }

  onChangeQuantityMaxP(ev, val) {
    this.setState({ quantityMaxP: val });
    this.quantityMaxPChanged(val);
  }


  onContractOptionChange(option) {
    this.props.onChangeFunc({ ...this.state, contractOption: option.value });
    this.setState({ contractOption: option.value });
    this.props.handleFormChanged();
  }

  setNewState(props, forceReinit = false) {
    if ((props && props.data && props.data.size !== 0 && props.updateOnNewProps
      && this.props.data != props.data)
      || this.state.init == false || forceReinit) {
      const quantity = this.getValue(props.data, 'quantity') || '';
      this.setState({
        absolute: this.isAbosulte(props.data),
        quantity,
        quantityMin: this.getValue(props.data, 'quantityMin') || '',
        quantityMax: this.getValue(props.data, 'quantityMax') || '',
        quantityMinP: this.formatQuantityP(this.getValue(props.data, 'quantityMinP')),
        quantityMaxP: this.formatQuantityP(this.getValue(props.data, 'quantityMaxP')),
        quantityMaxPReal: '',
        quantityMinPReal: '',
        init: true,
        contractOption: this.getValue(props.data, 'contractOption', 'MUTUAL_OPTION'),
        noTransportBl: this.getValue(props.data, 'noTransportBl') || false,
        billLandingQuantity: Number(this.getValue(props.data, 'billLandingQuantity', 0)),
        billLadingDate: this.getValue(props.data, 'billLadingDate') || undefined,
        completedLink: this.getValue(props.data, 'completedLink') || undefined,
        shrinkageIsPercentage: this.getValue(props.data, 'shrinkageIsPercentage') || false,
        shrinkage: this.getValue(props.data, 'shrinkage') || '',
        shrinkagePercent: this.getValue(props.data, 'shrinkagePercent') || '',
      });
    }
    if (props.validateAgainst && !this.state.validateAgainstUnlinked) {
      let validateAgainst = props.validateAgainst;
      if (props.isLinkingToExisting !== undefined && props.existingLinkIdx !== undefined) {
        validateAgainst = validateAgainst.deleteIn(['purchaseLink', props.existingLinkIdx]);
        validateAgainst = validateAgainst.deleteIn(['saleLink', props.existingLinkIdx]);
      }
      const validateAgainstUnlinked = calculateUnlinkedObject(validateAgainst);
      this.setState({ validateAgainstUnlinked });
    }
  }

  setAbsoluteBased() {
    const oldValues = {
      quantity: this.state.quantity,
      quantityMinP: this.state.quantityMinP,
      quantityMaxP: this.state.quantityMaxP,
    };
    const state =
      {
        ...this.state,
        absolute: true,
        quantity: '',
        quantityMinP: '',
        quantityMaxP: '',
        old: oldValues,
      };

    this.setState(state);
    this.validate(state);
    if (this.props.onChangeFunc) {
      this.props.onChangeFunc(state);
    }
  }

  setPercentBased() {
    const quantity = this.state.old ? this.state.old.quantity : '';
    const quantityMinP = this.state.old ? this.state.old.quantityMinP : '';
    const quantityMaxP = this.state.old ? this.state.old.quantityMaxP : '';
    const state =
      {
        ...this.state,
        absolute: false,
        quantityMin: quantity ?
          this.quantityMinCalc(quantity, quantityMinP) : this.state.quantityMin,
        quantityMax: quantity ?
          this.quantityMaxCalc(quantity, quantityMaxP) : this.state.quantityMax,
        quantity,
        quantityMinP,
        quantityMaxP,
      };
    this.onChangeQuantity(null, quantity);
    this.onChangeQuantityMinP(null, quantityMinP);
    this.onChangeQuantityMaxP(null, quantityMaxP);
    this.setState(state);
    this.validate(state);
    if (this.props.onChangeFunc) {
      this.props.onChangeFunc(state);
    }
  }


  getValue(data, field, defaultValue = '') {
    return data && (data.get(field) || data.get(field) == 0) ? data.get(field) : defaultValue;
  }

  setBlQuantity = (ev, value, changeFunc = true) => {
    this.props.setQuantity({ failed: false });
    this.validate({ ...this.state, billLandingQuantity: value });
    this.setState({ billLandingQuantity: value });
    // eslint-disable-next-line
    changeFunc && this.props.onChangeFunc
    && this.props.onChangeFunc({ ...this.state, billLandingQuantity: value });
    this.props.setBlQuantity(value);
  };

  setBlDate = (value, changeFunc = true) => {
    this.props.handleFormChanged();
    const newValue = value ? moment(value).format('DD MMM YYYY') : undefined;
    this.setState({ billLadingDate: newValue });
    // eslint-disable-next-line
    changeFunc && this.props.onChangeFunc
    && this.props.onChangeFunc({ ...this.state, billLadingDate: value });
    this.props.setBLDate(newValue);
  };

  validate(obj, props = this.props, propChangedCall = false) {
    if (this.state.validateAgainstUnlinked && props.isLinking) {
      const min1 = this.state.validateAgainstUnlinked.quantityMin
        ? this.state.validateAgainstUnlinked.quantityMin : 0;
      const max1 = this.state.validateAgainstUnlinked.quantityMax
        ? this.state.validateAgainstUnlinked.quantityMax : 0;
      let min2 = Infinity;
      let max2 = Infinity;
      if (props.unlinkedObject) {
        min2 = props.unlinkedObject.quantityMin ?
          props.unlinkedObject.quantityMin : 0;
        max2 = props.unlinkedObject.quantityMax ?
          props.unlinkedObject.quantityMax : 0;
      }

      let blQuantity = props.data.get('billLandingQuantity');
      if (blQuantity && props.showBLQuantity && blQuantity > max2) {
        this.props.setQuantity({ failed: true });
        return;
      }
      const mnq = this.props.multiNodalQuantity;
      if (mnq && blQuantity && props.showBLQuantity && blQuantity > mnq) {
        this.props.setQuantity({ failed: true });
        this.failed = true;
        return;
      }
      if (mnq && obj.quantityMax > mnq) {
        this.props.setQuantity({ failed: true });
        this.failed = true;
        return;
      }
      blQuantity = obj.billLandingQuantity;
      if (blQuantity && obj.noTransportBl && blQuantity > Math.min(max1, max2)) {
        this.props.setQuantity({ failed: true });
        return;
      }
      if (Number.parseInt(Math.min(min1, min2) * 1000.0, 10)
        >= Number.parseInt((obj.quantityMax !== '' ? obj.quantityMax : 0) * 1000.0, 10)) {
        this.setState({
          validationMessage: '',
        });
        if (propChangedCall) {
          this.props.setQuantity({ failed: false });
        } else {
          this.props.setLinkFirst();
        }
      } else if (Number.parseInt(Math.min(max1, max2) * 1000.0, 10)
        >= Number.parseInt((obj.quantityMin !== '' ? obj.quantityMin : 0) * 1000.0, 10)) {
        // this.setState({
        //   validationMessage: 'Warning: there may not be enough quantity to make the link' });
        this.setState({ validationMessage: '' });
        this.props.setLinkFirst();
        if (propChangedCall) {
          this.props.setQuantity({ failed: false });
        } else {
          this.props.setLinkFirst();
        }
      } else {
        this.failed = true;
        this.props.setQuantity({ failed: true });
        this.props.setLinkLast();
      }
    }
  }

  calcRangeQuantity(quantity = 0, quantityMinP = 0, quantityMaxP = 0) {
    // eslint-disable-next-line
    quantityMinP = quantityMinP ? quantityMinP : 0;
    // eslint-disable-next-line
    quantityMaxP = quantityMaxP ? quantityMaxP : 0;
    // eslint-disable-next-line
    quantity = quantity ? quantity : 0;
    this.failed = false;

    let quantityMinNew = quantity;
    let quantityMaxNew = quantity;

    if (quantity) {
      if (quantityMinP) {
        quantityMinNew = this.quantityMinCalc(quantity, quantityMinP);
      }
      if (quantityMaxP) {
        quantityMaxNew = this.quantityMaxCalc(quantity, quantityMaxP);
      }
    }

    this.validate(
      {
        ...this.state,
        quantity,
        quantityMin: quantityMinNew,
        quantityMax: quantityMaxNew,
      });
    if (this.props.onChangeFunc) {
      this.props.onChangeFunc(
        {
          ...this.state,
          quantity,
          quantityMinP,
          quantityMaxP,
          quantityMin: quantityMinNew,
          quantityMax: quantityMaxNew,
          failed: this.failed,
        });
    }
    this.props.setQuantity(
      {
        max: Number.parseFloat(quantityMaxNew).toFixed(3),
        min: Number.parseFloat(quantityMinNew).toFixed(3),
        failed: this.failed,
      });
    this.setState(
      {
        quantityMin: quantityMinNew,
        quantityMax: quantityMaxNew,
        showAlert: quantityMinNew >= this.props.alertOnQuantityGtThan,
      });
  }

  quantityMinPChanged(value) {
    this.calcRangeQuantity(this.state.quantity, value, this.state.quantityMaxP);
  }

  quantityMaxPChanged(value) {
    this.calcRangeQuantity(this.state.quantity, this.state.quantityMinP, value);
  }

  quantityMaxCalc(quantity, quantityMaxP) {
    const maxP = quantityMaxP && quantityMaxP !== '' ? quantityMaxP : 0;
    return quantity && quantity !== '' ? (quantity * (1 + maxP / 100.0)).toFixed(3) : 0;
  }

  quantityMinCalc(quantity, quantityMinP) {
    const minP = quantityMinP && quantityMinP !== '' ? quantityMinP : 0;
    return quantity && quantity !== '' ? (quantity * (1 - minP / 100.0)).toFixed(3) : 0;
  }

  quantityChanged(value) {
    this.calcRangeQuantity(value, this.state.quantityMinP, this.state.quantityMaxP);
  }

  isAbosulte(data) {
    if (data) {
      const quantity = this.getValue(data, 'quantity') || '';
      const quantityMin = this.getValue(data, 'quantityMin') || '';
      const quantityMax = this.getValue(data, 'quantityMax') || '';
      return (quantity === '' && (quantityMin !== '' || quantityMax !== ''));
    }
    return false;
  }

  formatQuantityP(value) {
    return value === '0' ? '' : value;
  }

  hideAlert = () => this.setState({ showAlert: false });

  handleBLDateChange = (e) => {
    const checked = e.target.checked;
    this.setState({ noTransportBl: checked });
    this.props.setNoTransportBl(checked);
    if (!checked) {
      this.setBlQuantity(null, 0, false);
      this.setBlDate(undefined, false);
      if (this.props.onChangeFunc) {
        this.props.onChangeFunc({
          ...this.state, billLadingDate: undefined,
          billLandingQuantity: null,
        });
      }
    }
  };

  handleShrinkageAbsoluteSelect = () => {
    this.setState({ shrinkageIsPercentage: false });
    this.props.onChangeFunc({
      ...this.state,
      shrinkageIsPercentage: false,
    });
    this.props.handleFormChanged();
  };

  handleShrinkagePercentSelect = () => {
    this.setState({ shrinkageIsPercentage: true });
    this.props.onChangeFunc({
      ...this.state,
      shrinkageIsPercentage: true,
    });
    this.props.handleFormChanged();
  };

  handleShrinkageValueChange = (ev, val) => {
    this.setState({ shrinkage: val });
    this.props.onChangeFunc({
      ...this.state,
      shrinkage: val,
    });
    this.props.handleFormChanged();
  };

  handleShrinkagePercentChange = (ev, val) => {
    this.setState({ shrinkagePercent: val });
    this.props.onChangeFunc({
      ...this.state,
      shrinkagePercent: val,
    });
    this.props.handleFormChanged();
  };

  render() {
    let disabled = this.props.disabled;
    if (disabled === undefined) disabled = this.context.disabled;
    const blQuantity = this.props.data.get('billLandingQuantity');
    const hasTransport = !!this.props.data.get('transport')
      || this.props.data.get('transport') === 0;
    const hasLinks = this.props.links && this.props.links.filter(l => !l.get('hidden')).size;
    const contractOption = this.props.showContractOption ? (
      <Row style={{ paddingBottom: 15 }}>
        <Col xs={10} xsOffset={2}>
          <Select
            id="contractOption"
            name="contractOption"
            value={this.state.contractOption}
            onChange={this.onContractOptionChange}
            clearable={false}
            options={[
              { value: 'MUTUAL_OPTION', label: 'Mutual option' },
              { value: 'BUYER_OPTION', label: 'Buyer option' },
              { value: 'SELLER_OPTION', label: 'Seller option' },
            ]}
            disabled={disabled || this.state.billLandingQuantity}
          />
        </Col>
      </Row>) : '';
    const unlinked = this.props.showUnlinked ?
      <Row>
        <Col
          xs={12} sm={this.props.showShrinkage ? 12 : 4}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
            flexWrap: 'wrap',
          }}
        >
          <span
            className={'unlinked-product-label'}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <img src={longshort} className={'unlinked_arrow'} role="presentation" />
            <span className={'unlinked_text'}>
              {!this.props.dealType && 'Unlinked'}
              {this.props.dealType && (this.props.dealType === 'purchase' ? 'Long' : 'Short')}
            </span>
          </span>
          <b style={{ minWidth: 85 }}>
            {calculateUnlinked(fromJS(this.state),
              this.props.links ? this.props.links : new List())}
          </b>
          <span className={'transport-buttons'} style={{ paddingTop: 0 }}>
            <Button
              style={{ padding: '2px 5px', margin: '0 0 0 10px', fontSize: 12 }}
              bsStyle={this.state.completedLink ? 'primary' : 'gray'}
              onClick={() => {
                this.setState({ completedLink: !this.state.completedLink });
                this.props.onChangeFunc({
                  ...this.state,
                  completedLink: !this.state.completedLink,
                });
                this.props.handleFormChanged();
              }}
            >Set 0</Button>
          </span>
        </Col>
      </Row> : '';
    const rootStyle = {};
    if (this.props.shrinked) {
      rootStyle.height = 'auto';
      if (this.props.handleSelected) {
        rootStyle.cursor = 'pointer';
      }
    }
    const link = this.props.link;

    const showSetBl = !link && !this.props.showUnlinked && !hasTransport
      && this.props.dealType !== 'transport';
    return (
      <div
        className={this.props.dealType === 'transport' ? 'quantity-wrapper' : ''}
        style={rootStyle}
        onClick={this.props.handleSelected || (() => {
        })}
      >
        <div className={this.props.dealType === 'transport' ? 'new-link' : 'hidden'}>New link</div>
        <div
          className={`quantityBlock ${this.props.shrinked ? 'hidden' : ''}`}
          id={`quantity-${this.props.id ? this.props.id : ''}`}
        >
          {this.state.showAlert && <AlertPopover
            data={`Entered quantity is greater than ${formatNumber(
              this.props.alertOnQuantityGtThan, '0,0.[000]')}!`}
            target={`quantity-input${this.props.id ? this.props.id : ''}`}
            placement="top"
            hideAlert={this.hideAlert}
            show={this.state.showAlert}
          />
          }
          {showSetBl &&
            <div className={'quantity'}>
              <Row>
                <Col xs={12} style={{ paddingLeft: 30 }}>
                  <Checkbox
                    id="noTransportBl"
                    hame="noTransportBl"
                    checked={this.state.noTransportBl}
                    onChange={this.handleBLDateChange}
                  >Link without transport</Checkbox>
                </Col>
              </Row>
            </div>
          }
          <Label
            vertical={this.props.vertical}
            label={blQuantity && this.props.showBLQuantity ? '' : 'Quantity'}
          >
            <Row >
              <Col xs={12}>
                {blQuantity && this.props.showBLQuantity && !showSetBl ?
                  <div
                    style={{
                      height: '150px', display: 'flex',
                      alignItems: 'center',
                    }}
                  >{`BL Quantity: ${blQuantity}`}</div>
                  :
                  <div>
                    <Row style={{ paddingBottom: 5 }}>
                      <Col xs={2}>
                        <Radio
                          id="quantityPercent"
                          onChange={this.setPercentBased}
                          checked={!this.state.absolute}
                          disabled={disabled || this.state.billLandingQuantity}
                        />
                      </Col>
                      <Col
                        xs={10}
                        id={`quantity-input${this.props.id ? this.props.id : ''}`}
                      >
                        <RequiredFormControl
                          component={FancyInput}
                          disableRequired={disabled || this.state.absolute || !hasLinks}
                          className="form-control"
                          thousand
                          fraction={3}
                          positive
                          negative={false}
                          type="number"
                          id="quantity" name="quantity"
                          disabled={disabled || this.state.absolute
                          || this.state.billLandingQuantity}
                          value={this.state.quantity}
                          onChange={this.onChangeQuantity}
                        />
                      </Col>
                    </Row>
                    <Row style={{ paddingBottom: 15 }}>
                      <Col xs={2} />
                      <Col xs={5}>
                        <InputGroup>
                          <FancyInput
                            className="form-control"
                            name="quantityMinP"
                            disabled={disabled || this.state.absolute ||
                          this.state.billLandingQuantity}
                            thousand
                            fraction={0}
                            positive
                            negative={false}
                            maxValue={100}
                            id="quantityMinP"
                            value={this.state.quantityMinP}
                            onChange={this.onChangeQuantityMinP}
                          />
                          <InputGroup.Addon
                            className={disabled || this.state.absolute ||
                            this.state.billLandingQuantity ? 'input-group-addon-disabled' : ''}
                          >
                          -%
                          </InputGroup.Addon>
                        </InputGroup>
                      </Col>
                      <Col xs={5}>
                        <InputGroup>
                          <FancyInput
                            className="form-control"
                            disabled={disabled || this.state.absolute ||
                          this.state.billLandingQuantity}
                            name="quantityMaxP"
                            thousand
                            fraction={0}
                            positive
                            negative={false}
                            maxValue={100}
                            id="quantityMaxP"
                            value={this.state.quantityMaxP}
                            onChange={this.onChangeQuantityMaxP}
                          />
                          <InputGroup.Addon
                            className={disabled || this.state.absolute ||
                            this.state.billLandingQuantity ? 'input-group-addon-disabled' : ''}
                          >
                          +%
                          </InputGroup.Addon>
                        </InputGroup>
                      </Col>

                    </Row>
                    {!this.state.absolute ? contractOption : ''}
                    <Row style={{ paddingBottom: 15 }}>
                      <Col xs={2}>
                        <Radio
                          id="quantityAbsolute"
                          onChange={this.setAbsoluteBased}
                          checked={this.state.absolute}
                          disabled={disabled || this.state.billLandingQuantity}
                        />
                      </Col>
                      <Col xs={10}>
                        <Row>
                          <Col xs={5}>
                            <RequiredFormControl
                              component={FancyInput}
                              disableRequired={disabled || !this.state.absolute || !hasLinks}
                              className="form-control"
                              thousand
                              fraction={3}
                              positive
                              negative={false}
                              type="number"
                              disabled={disabled || !this.state.absolute ||
                          this.state.billLandingQuantity}
                              name="quantityMin"
                              value={this.state.quantityMin}
                              onChange={this.onChangeQuantityMin}
                            />
                          </Col>
                          <Col xs={2} style={{ textAlign: 'center' }}>-</Col>
                          <Col xs={5}>
                            <RequiredFormControl
                              component={FancyInput}
                              disableRequired={disabled || !this.state.absolute || !hasLinks}
                              className="form-control"
                              thousand
                              fraction={3}
                              positive
                              negative={false}
                              type="number"
                              disabled={disabled || !this.state.absolute ||
                          this.state.billLandingQuantity}
                              name="quantityMax"
                              value={this.state.quantityMax}
                              onChange={this.onChangeQuantityMax}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                }
              </Col>
              {this.state.absolute ? <Col xs={12}>{contractOption}</Col> : ''}
              {this.props.showShrinkage ? undefined : unlinked}
            </Row>
          </Label>
          {this.props.showShrinkage ? <Row>
            <Col xs={12} md={10} mdOffset={2}>
              <Label
                vertical={this.props.vertical}
                label="Shrinkage" labelClassName={'shrinkage-label'}
              >
                <Row>
                  <Col md={6} xs={10} className={'shrinkage'}>
                    <Radio
                      id={`${!this.state.shrinkageIsPercentage} shrinkageAbsolute`}
                      onChange={this.handleShrinkageAbsoluteSelect}
                      inline
                      checked={!this.state.shrinkageIsPercentage}
                      disabled={disabled}
                    />
                    <InputGroup>
                      <FancyInput
                        className="form-control"
                        name="shrinkage"
                        disabled={disabled || this.state.shrinkageIsPercentage}
                        thousand
                        fraction={3}
                        id="shrinkage"
                        value={this.state.shrinkageIsPercentage ? '' : this.state.shrinkage}
                        onChange={this.handleShrinkageValueChange}
                      />
                    </InputGroup>
                    <Radio
                      id={`${this.state.shrinkageIsPercentage} shrinkagePercent`}
                      onChange={this.handleShrinkagePercentSelect}
                      inline
                      checked={this.state.shrinkageIsPercentage}
                      disabled={disabled}
                    />
                    <InputGroup className={'shrinkage-percent-input'}>
                      <FancyInput
                        className="form-control"
                        name="shrinkagePercent"
                        disabled={disabled || !this.state.shrinkageIsPercentage}
                        fraction={2}
                        maxValue={100}
                        id="shrinkagePercent"
                        value={this.state.shrinkageIsPercentage ? this.state.shrinkagePercent : ''}
                        onChange={this.handleShrinkagePercentChange}
                      />
                      <InputGroup.Addon
                        className={disabled || !this.state.shrinkageIsPercentage
                          ? 'input-group-addon-disabled' : ''}
                      >
                  %
                      </InputGroup.Addon>
                    </InputGroup>
                  </Col>
                  <Col md={6} xs={12} className={'shrinkage-unlinked'}>
                    {unlinked}
                  </Col>
                </Row>
              </Label>
            </Col>
          </Row> : undefined
          }
          {showSetBl &&
            <div className={'quantity'}>
              <Label
                label="B/L Quantity & date"
                style={{ paddingRight: 0, width: '37.33%' }}
                childStyle={{ width: '62.67%' }}
              >
                <Grid fluid style={{ paddingRight: 0, paddingLeft: 0 }}>
                  <div>
                    {!this.state.absolute ? contractOption : ''}
                    <Row style={{ paddingBottom: 15 }}>
                      <Col xs={12} style={{ paddingLeft: 0 }}>
                        <Col xs={6} style={{ paddingLeft: 0, paddingRight: 5 }}>
                          <FancyInput
                            className="form-control"
                            thousand
                            fraction={3}
                            positive
                            negative={false}
                            type="number"
                            value={this.state.billLandingQuantity}
                            id="billLandingQuantity"
                            onChange={this.setBlQuantity}
                            disabled={disabled || !this.state.noTransportBl}
                          />
                        </Col>
                        <Col xs={6} style={{ paddingLeft: 5, paddingRight: 0 }}>
                          <DateTimePicker
                            format={dateTimePickerFormat}
                            time={false}
                            name="billLadingDate"
                            value={this.state.billLadingDate ?
                              moment(this.state.billLadingDate,
                                dateTimePickerFormat).toDate() : undefined}
                            onChange={this.setBlDate}
                            disabled={disabled || !this.state.noTransportBl}
                          />
                        </Col>
                      </Col>
                    </Row>
                  </div>
                </Grid>
              </Label>
            </div>
          }
          {// eslint-disable-next-line
            this.props.validateAgainst ?
              this.props.thisElemInState &&
              (this.props.thisElemInState.get('failed') ||
                this.props.thisElemInState.get('groupCheckFailed'))
                ?
                <Col
                  xs={12} id="quantityWarningBlock"
                  className={'quantity-error'}
                >Error! There is not enough quantity to link
                </Col>
                : <Col
                  xs={12} id="quantityWarningBlock"
                >
                  {this.state.validationMessage}
                </Col>
              : ''}
        </div>
      </div>);
  }
}

export default connect(
  (state, props) => ({
    thisElemInState: state.getIn(['links', 'quantity', props.id]),
    validateAgainst: state.getIn(['links', 'data', 'productToLinkIdx']) === undefined ? undefined :
      state.getIn(['data', 'deals', 'deal', 'products'], new List())
        .get(state.getIn(['links', 'data', 'productToLinkIdx'])),
    isLinkingToExisting: state.getIn(['links', 'data', 'linkToExistingLink'])
      && state.getIn(['links', 'data', 'productToLinkIdx'])
      && state.getIn(['links', 'data', 'linkIdx']),
    existingLinkIdx: state.getIn(['links', 'data', 'linkIdx']),
  })
  , (dispatch, props) => ({
    setLinkSavingAllowed(bool) {
      setLinkSavingAllowed(dispatch, bool);
    },
    setQuantity(quantity) {
      setQuantity(dispatch, props.id, quantity);
    },
    setBlQuantity(quantity) {
      setBlQuantity(dispatch, props.id, quantity);
    },
    setBLDate(date) {
      setBLDate(dispatch, props.id, date);
    },
    setNoTransportBl(value) {
      setNoTransportBl(dispatch, props.id, value);
    },
    setLinkFirst() {
      setLinkFirst(dispatch, props.id);
    },
    setLinkLast() {
      setLinkLast(dispatch, props.id);
    },
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
  }))(Quantity);

Quantity.propTypes = {
  updateOnNewProps: React.PropTypes.bool,
  data: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  onChangeFunc: React.PropTypes.func,
  validateAgainst: React.PropTypes.object,
  setLinkSavingAllowed: React.PropTypes.func,
  id: React.PropTypes.string,
  setQuantity: React.PropTypes.func,
  setBlQuantity: React.PropTypes.func,
  setBLDate: React.PropTypes.func,
  setNoTransportBl: React.PropTypes.func,
  setLinkFirst: React.PropTypes.func,
  setLinkLast: React.PropTypes.func,
  thisElemInState: React.PropTypes.object,
  unlinkedObject: React.PropTypes.object,
  showContractOption: React.PropTypes.bool,
  isLinking: React.PropTypes.bool,
  links: React.PropTypes.object,
  showUnlinked: React.PropTypes.bool,
  handleFormChanged: React.PropTypes.func,
  showBLQuantity: React.PropTypes.bool,
  dealType: React.PropTypes.string,
  alertOnQuantityGtThan: React.PropTypes.number,
  link: React.PropTypes.number,
  shrinked: React.PropTypes.bool,
  handleSelected: React.PropTypes.func,
  multiNodalQuantity: React.PropTypes.number,
  showShrinkage: React.PropTypes.bool,
  vertical: React.PropTypes.bool,
};

Quantity.contextTypes = {
  disabled: React.PropTypes.bool,
};
